export default __webpack_public_path__ + "static/media/Poke_Shield.a63a9b6c.png";